// extracted by mini-css-extract-plugin
module.exports = {"mini":"miniFooter_mini__eUwer","footer":"miniFooter_footer__fc6AM","copyright":"miniFooter_copyright__rxQDD","links":"miniFooter_links__3w31Q"};